import ImageZoom from '../../commons/ImageZoom';
import './JavaCoffee.css';

const JavaCoffee = () => {
    return (
      <div className="portfolio">
        <header className="portfolio-header">
          <h1>Java Coffee</h1>
          <p>Présentation du projet</p>
        </header>
  
        <section className="portfolio-section">
          <h2>Fonctionnalités</h2>
          <div className="portfolio-projects">
            <div className="project">
              <ImageZoom alt={''} src={'./assets/java-login.jpg'}/>
              <h3 className='mt-3'>Code à usage unique</h3>
              <p>Durant une période de 8 mois, 16000 codes ont été placés dans des sachets de café. Ces codes permettaient aux acheteurs des sachets d'otenir une participation au jeu et de remporter un prix.</p>
            </div>
            <div className="project">
            <ImageZoom alt={''} src={'./assets/java-game.jpg'}/>
              <h3 className='mt-3'>Règles du jeu</h3>
              <p>Après un tutoriel explicatif, les joueurs avaient pour objectif de ramasser les graines en bon état pour remplir la barre de progression à 100%, tout en évitant les mauvaises graines. Une fois la barre de progression remplie, les 3 grains dorés tombent, si le joueur récupère ces 3 grains dorés, il est éligible pour gagner un lot.</p>
            </div>
            <div className="project">
            <ImageZoom alt={''} src={'./assets/java-win.jpg'}/>
              <h3 className='mt-3'>Cadeaux</h3>
              <p>Plusieurs cadeaux ont été répartis durant la période de 8 mois, dont 2 machines à café, 15 paquets de café, et des bons de réduction.</p>
            </div>
          </div>
        </section>
  
        <section className="portfolio-section">
          <h2>À propos du projet</h2>
          <p>
          Dans le cadre d’une campagne ludique et innovante pour la marque Java, j’ai conçu un jeu 2D captivant, accessible grâce à des codes uniques que les utilisateurs pouvaient trouver dans des sachets de café spécialement marqués. Une fois le code entré sur la plateforme dédiée, les participants plongeaient dans un univers où ils devaient contrôler un sac de café à l’aide de leur curseur.
          <br />
          Le but du jeu ? Récupérer 10 graines de café éparpillées à travers le tableau en évitant les obstacles et en testant leur habileté. Mais le défi ne s’arrêtait pas là. Une fois les 10 graines collectées, un dernier objectif se présentait aux joueurs : Ils devaient attraper 3 grains de café dorés, symboles de qualité et de succès. Ces grains dorés étaient la clé pour rendre leur participation éligible au concours et ainsi leur donner une chance de remporter des prix exclusifs.
          <br />
          L’expérience de jeu alliait simplicité et divertissement, tout en renforçant l’attachement des utilisateurs à la marque au travers d'une interaction dynamique et engageante.
          </p>
          <img width={'50%'} src="./assets/java-logo.jpg" alt="Moi" className="about-image" />
        </section>
  
        <footer className="portfolio-footer">
          <a href="mailto:julien.j.1999@hotmail.com">Contactez-moi: julien.j.1999@hotmail.com</a>
        </footer>
      </div>
    );
  };
  
  export default JavaCoffee;